import {
  html,
  SYSBaseElement,
  SYSFormElement,
} from "../../../../../../../_ovlclient/src"
import { T } from "../../../../../../../_ovlclient/src/global/globals"

export class ScreenSearchPaket extends SYSFormElement {
  async init() {
    this.formType = "DATSearchPaket"
    await super.init()
  }
  async getUI() {
    let formState = this.formState
    let formField = formState.fields["Search"]

    let search = html`<div class="searchpaket">
      <ovl-listcontrol .props=${() => formField}></ovl-listcontrol>
    </div>`

    let searchPaket = this.state.app.screens.DATOrder.orderDetailFormState
    return html`
      <div class="ovl-smart-screen-margins-lr">
        <div class="fd-layout-panel">
          <div class="searchpaketfixed">
            <div class="fd-layout-panel__header">
              <div class="fd-layout-panel__head">
                <h3 class="fd-layout-panel__title">
                  ${T("SPKSearchPaketSearchPaket", [
                    searchPaket.selectedOrder,
                    this.state.app.screens.DATOrder.orderDetail.orders[
                      searchPaket.selectedOrder
                    ].refNum,
                  ])}
                </h3>
              </div>
            </div>
            ${search}
          </div>
          <div class="fd-layout-panel__body">
            <ovl-table class="fd-table" .props=${() => "DATSearchPaket"}>
            </ovl-table>
          </div>
        </div>
      </div>
    `
  }
}
